import React from "react";

import { Typography } from "@mui/material";

import FactureSvg from "../../../../Assets/svg/FactureSvg";
import CustomHeader from "../CustomHeader/CustomHeader";

const HeaderFactures: React.FC = () => (
  <CustomHeader
    childLeft={
      <div
        style={{
          alignItems: "flex-start",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{ fontSize: 24, fontWeight: "bold", color: "#ffffff" }}
        >
          Mes Factures
        </Typography>
      </div>
    }
    icon={
      <FactureSvg
        viewBox="0 0 20 15"
        fill="#ffffff50"
        style={{
          height: "172px",
          width: "425px",
        }}
      />
    }
  />
);

export default HeaderFactures;
